<template>
  <div class="section">
    <div class="l-section">
      <div class="row">
        <img class="icon" src="@/assets/image/email-icon.png" />
        <div class="col">
          <div>
            <span class="name">邮箱认证</span
            ><span style="color: #ff5c35; margin-left: 10px; font-size: 18px"
              >({{ details.emailCount }})</span
            >
          </div>
          <div class="label">
            邮箱认证后可用来接收智绘网络发送的各类系统、营销、服务通知
          </div>
        </div>
      </div>
      <Button class="btn-height45" to="/user/account/myEmail">查看</Button>
    </div>
    <div class="l-section">
      <div class="row">
        <img class="icon" src="@/assets/image/user-icon.png" />
        <div class="col">
          <div>
            <span class="name">个人认证</span
            ><span style="color: #ff5c35; margin-left: 10px; font-size: 18px"
              >({{ details.userIdentityCount }})</span
            >
          </div>
          <div class="label">适用个人用户，账号归属于个人</div>
        </div>
      </div>
      <Button class="btn-height45" to="/user/account/myPersonal">查看</Button>
    </div>
    <div class="l-section">
      <div class="row">
        <img class="icon" src="@/assets/image/enterprise-icon.png" />
        <div class="col">
          <div>
            <span class="name">企业认证</span
            ><span style="color: #ff5c35; margin-left: 10px; font-size: 18px"
              >({{ details.enterpriseIdentityCount }})</span
            >
          </div>
          <div class="label">
            适用企业、个体工商户、政府、事业单位、学校、组织等，账号归属企业
          </div>
        </div>
      </div>
      <Button class="btn-height45" to="/user/account/myEnterprise">查看</Button>
    </div>
  </div>
</template>

<script>
import { myCertification } from "api/user.js";
export default {
  name: "security",
  data() {
    return {
      details: {
        emailCount: 0,
        emailList: [],
        enterpriseIdentityCount: 0,
        enterpriseIdentityList: [],
        userIdentityCount: 0,
        userIdentityList: [],
      },
    };
  },
  created() {
    this.req_getInfo();
  },
  methods: {
    async req_getInfo() {
      try {
        const { code, data } = await myCertification();
        if (code === 200) {
          this.details = data;
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.section {
  background-color: #fff;
  border-radius: 8px;
  padding: 50px;
}
.l-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 40px 0;
  border-bottom: 1px solid #eaeaea;
  .row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .icon {
      width: 50px;
      height: 50px;
    }
    .col {
      margin-left: 20px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .name {
        color: #333333;
        font-weight: bold;
        font-size: 18px;
      }
      .label {
        color: #999999;
      }
    }
  }
}
.btn-height45 {
  height: 45px;
  line-height: 45px;
  min-width: 80px;
}
</style>
